<template>
<v-container fluid class="mx-2">
  <v-alert v-model="alert" dismissible :color="alert_color" border="left" elevation="2" colored-border icon="mdi-check">
    {{alert_message}}
  </v-alert>
  <v-row justify="center">


    <v-col cols="12">
      <v-sheet rounded="lg">
        <v-toolbar flat color="transparent">
          <v-toolbar-title>
            Shuttle Options
          </v-toolbar-title>
        </v-toolbar>
        <v-data-table :loading="loading" :headers="headers" :items="settingsItems" item-key="name" class="elevation-1" :search="search"
        >
          <template v-slot:top>
            <v-row>
              <v-col>
            <v-text-field color="secondary" v-model="search" label="Search" class="mx-4"></v-text-field>
          </v-col>
          <v-col>
            <!-- dialog start -->
            <v-dialog v-model="dialog" max-width="900">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="secondary" dark v-bind="attrs" v-on="on">
                  Create
                </v-btn>
              </template>

              <v-card>
                <v-card-title class="headline grey lighten-2">
                  Create Setting Form
                </v-card-title>

                <v-container>
                  <v-select
                    label="Select a template"
                    dense
                    outlined
                    v-model="selectedTemplate"
                    :items="templateItems"
                    item-text="name"
                    item-value="setting_id"
                    return-object
                    :loading="loading_templates"
                    @input="setCreationForm($event)"
                   ></v-select>
                </v-container>



                <v-divider></v-divider>

                <v-container>
                  <div class="card pl-4 pt-5 pb-5 pr-4 mt-5">
                    <form action="" @submit.prevent="submitCreationForm">
                      <vue-form-generator ref="authorCreationForm" tag="div" :schema="schema" :options="formOptions" :model="model" />
                      <div class="d-flex justify-content-end mt-3 pr-4">
                        <v-btn @click="cancelCreation()" color="primary" class="mx-2">Cancel</v-btn>
                        <button type="submit" class="btn btn-primary btn-md">
                          {{ isSaving ? 'Saving...' : 'Save'}}
                        </button>

                      </div>
                    </form>
                  </div>
                  <v-alert v-model="alert" dismissible :color="alert_color" border="left" elevation="2" colored-border icon="mdi-check">
                    {{alert_message}}
                  </v-alert>
                </v-container>

                <v-divider></v-divider>


                <v-card-actions>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
            <!-- dialog end -->
          </template>
          <template v-slot:item.display_name="{ item }">
            {{ item.model['setting-name'] }}
          </template>
          <template v-slot:item.description="{ item }">
            {{ item.model['setting-description'] }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <!--<v-icon small @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          -->
          </template>
          <!--<template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
              Reset
            </v-btn>
          </template>
          -->
        </v-data-table>
      </v-sheet>
    </v-col>
    <!--
            <v-col
              cols="12"
              sm="2"
            >
              <v-sheet
                rounded="lg"
                min-height="268"
              >

              </v-sheet>
            </v-col>
          -->
  </v-row>
</v-container>
</template>
<script>
import {
  mapState
} from 'vuex';
import ShuttleMixins from '@/mixins/ShuttleMixins.js';
import userFormSchema from '../../forms/userFromSchema.js';
import { v4 as uuidv4 } from 'uuid';
export default {
  name: 'ShuttlesettingsItems',
  mixins: [ShuttleMixins],
  data() {
    return {
      loading: true,
      loading_templates: false,
      dialog: false,
      settingsItems: [],
      templateItems: [],
      selectedTemplate: {},
      headers: [{
          text: 'Name',
          value: 'display_name'
        },
        {
          text: 'Description',
          value: 'description'
        },
        {
          text: 'Last Modified',
          value: 'last_modified'
        },
        {
          text: 'Created',
          value: 'created_on'
        },
        {
          text: '',
          value: 'actions',
          sortable: false
        },
      ],
      search: '',

      alert: false,
      alert_message: '',
      alert_color: 'green',
      alert_timeout_duration: 4200,
      model: {},
      schema: {},
      formOptions: {},
      isSaving: false,
      fieldSchema: userFormSchema,
    }
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    async loadItems() {
      this.loading = true;
      let path = this.$store.state.endpoint.post_customer + '/' + this.$store.state.auth.sub + '/settings',
        data;
      try {
        data = await this.getData(path + '?type=1&entity_type=user-settings-form', 'get');
        data = data.body.data.Items;
        for (var i = 0; i < data.length; i++) {
          data[i].display_name = data[i].model['setting-name'];
          data[i].description = data[i].model['setting-description'];
        }
      } catch (err) {
        console.log("ERR", err);
      }
      this.settingsItems = data;
      this.loading = false;
    },
    editItem(item) {
      console.log("selected item", item);
      this.$router.push({
        path: '/settings/edit/' + item.setting_id
      });
    },
    cancelCreation() {
      this.model = {};
      this.schema = {};
      this.selectedTemplate = {};
      this.dialog = false;
    },
    async loadTemplates() {
      this.loading_templates = true;
      let path = this.$store.state.endpoint.post_customer + '/' + 'default' + '/settings',
        data;
      try {
        data = await this.getData(path + '?type=1&entity_type=template-user-settings-form', 'get');
        data = data.body.data.Items;
      } catch (err) {
        console.log("ERR", err);
      }
      this.templateItems = data;
      this.loading_templates = false;
      if (this.templateItems.length > 0) {
        this.selectedTemplate = this.templateItems[0];
        this.setCreationForm(this.selectedTemplate);
      }
    },
    setCreationForm(selected) {
      let data = selected;
      let groups = [];
      if (data.enabled) {
        data.enabled.forEach((fieldset) => {
          let fields = [];
          for (let i = 0; i < fieldset.fields.length;i++){
            fields.push(this.fieldSchema[fieldset.fields[i]]);
          }
          groups.push({
            "legend": fieldset.legend ? fieldset.legend : "",
            "fields": fields
          });
        });
      }
      this.schema = {
        "groups": groups
      };
      if (data.model) {
        this.model = data.model;
      }
    },
    async submitCreationForm() {
      let validate = this.$refs.authorCreationForm.vfg.validate();
      console.log("VALIDATE", validate);
      if (!validate) {
        this.formError("Invalid fields");
        return;
      }
      this.isSaving = true;
      let path = this.$store.state.endpoint.post_customer + '/' + this.$store.state.auth.sub + '/settings',
          updateResponse;
      try {
        let d = new Date().toISOString();
        let newItem = {
          customer_id: this.$store.state.auth.sub,
          setting_id: uuidv4(),
          model: this.model,
          last_modified: d,
          created_on: d,
          entity_type: 'user-settings-form',
          enabled: this.selectedTemplate.enabled
        };
        updateResponse = await this.getData(path, 'post', {
          type: 'create',
          item: newItem
        });
        this.formSuccess();
      } catch (e) {
        this.formError(e);
      }
      this.isSaving = false;
    },
    formError(e) {
      this.alert_color = "red";
      this.alert_message = "Failed to create new setting";
      this.alert = true;
      //this.cancelCreation();
      setTimeout(() => {
        this.alert = false;
      }, this.alert_timeout_duration);
    },
    formSuccess() {
      this.alert_color = "green";
      this.alert_message = "New setting created.";
      this.alert = true;
      this.loadItems();
      this.cancelCreation();
      setTimeout(() => {
        this.alert = false;
      }, this.alert_timeout_duration);
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.loadTemplates();
      }
      if (!this.dialog) {
        this.cancelCreation();
      }
    },
  }
}
</script>
